var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-gray"},[_c('i',{staticClass:"fa fa-clone fa-lg icon-button",attrs:{"title":"Copiar"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarCopiar()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }